// Orchard: PDP add-to-cart helpers — (1) a quantity stepper next to the buy
// button so shoppers can order more than one in a single tap, and (2) keep them
// on the page after adding (the render engine otherwise redirects to /checkout),
// updating the nav cart count so they can keep shopping. Additive and safe;
// remove the <script src='oe-cart-add.js'> include in layout/orchard.liquid to revert.
(function () {
  function flavor() { return (window.OE_FLAVOR || new URLSearchParams(location.search).get('f') || 'pineapple'); }
  function toast(msg) {
    var t = document.getElementById('toast'); if (!t) return;
    var s = t.querySelector('span'); if (s) s.textContent = msg;
    t.classList.add('on'); clearTimeout(t._tt); t._tt = setTimeout(function () { t.classList.remove('on'); }, 2000);
  }
  function updateCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = (c && c.item_count) || 0;
        var bs = document.querySelectorAll('.oe-cart-link .oe-cart-count');
        for (var i = 0; i < bs.length; i++) { if (n > 0) { bs[i].textContent = n; bs[i].style.display = 'block'; } else { bs[i].style.display = 'none'; } }
      }).catch(function () {});
  }
  function getQty() { var n = document.querySelector('.oe-qty-n'); var v = n ? parseInt(n.textContent, 10) : 1; return (v > 0 ? v : 1); }
  function setQty(v) { var n = document.querySelector('.oe-qty-n'); if (n) n.textContent = String(v < 1 ? 1 : v); }
  function injectQty() {
    var row = document.querySelector('#pdp .buyrow'); if (!row || row.querySelector('.oe-qty')) return !!row;
    var btnCss = 'width:42px;height:54px;border:0;background:transparent;color:inherit;font-family:inherit;font-size:22px;line-height:1;cursor:pointer;';
    var wrap = document.createElement('div');
    wrap.className = 'oe-qty';
    wrap.style.cssText = 'display:inline-flex;align-items:center;border:1.5px solid rgba(244,234,210,.4);border-radius:999px;overflow:hidden;margin-right:12px;color:#f4ead2;height:54px;vertical-align:middle;';
    wrap.innerHTML = '<button type="button" class="oe-qty-dec" aria-label="Decrease quantity" style="' + btnCss + '">\u2212</button><span class="oe-qty-n" aria-live="polite" style="min-width:30px;text-align:center;font-family:&#39;Space Mono&#39;,monospace;font-size:16px;">1</span><button type="button" class="oe-qty-inc" aria-label="Increase quantity" style="' + btnCss + '">+</button>';
    row.insertBefore(wrap, row.firstChild);
    wrap.querySelector('.oe-qty-dec').addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); setQty(getQty() - 1); }, true);
    wrap.querySelector('.oe-qty-inc').addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); setQty(getQty() + 1); }, true);
    return true;
  }
  function tryInject() { if (injectQty()) return; var n = 0, iv = setInterval(function () { if (injectQty() || ++n > 50) clearInterval(iv); }, 100); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInject); else tryInject();

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#buybtn') : null;
    if (!btn) return;
    var p = (window.PROD || {})[flavor()];
    if (!p) return; // no PDP data on this page (e.g. /pages/zingiez) — let the page's own buy handler work
    e.preventDefault();
    e.stopImmediatePropagation();
    var on = document.querySelector('.packs button.on');
    var pi = on ? (Number(on.dataset.i) || 0) : 0;
    var sub = !!document.querySelector('#subrow.on');
    var vid = p.vars && p.vars[pi];
    if (!vid) { toast('hmm \u2014 try that again'); return; }
    var item = { id: Number(vid), quantity: getQty() };
    if (sub && p.sub) { item.selling_plan = 2296676386; }
    btn.style.pointerEvents = 'none';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { btn.style.pointerEvents = ''; if (r.ok) { toast('added to your bag \u2726 \u00b7 tap the cart to check out'); updateCount(); } else { toast('hmm \u2014 try that again'); } })
      .catch(function () { btn.style.pointerEvents = ''; toast('hmm \u2014 try that again'); });
  }, true);
})();
